import { render, staticRenderFns } from "./ModelHeading.vue?vue&type=template&id=a9fa5306&scoped=true"
import script from "./ModelHeading.vue?vue&type=script&lang=js"
export * from "./ModelHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fa5306",
  null
  
)

export default component.exports